import copyToClipboard from 'copy-to-clipboard';

export const useClipboard = (): ((text: string) => void) => (text: string) => {
    copyToClipboard(text);
};
